import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Grid, Paper, Stack, Tab } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { LoadingWidget, ModalComponent } from '../../../../../../widgets';
import BotonComponent from '../../../../../dashboard/components/BotonNuevo';
import ActividadesExtrasView from '../../../actividades_extras/ActividadesExtrasView';
import { setActivoPevaActividadesAction } from '../../../peva_actividades/PevaActividadesAction';
import FormPevaActividades from '../../../peva_actividades/components/FormPevaActividades';
import { setActivoPlanevaTemasAction } from '../../../planeva_temas/PlanevaTemasAction';
import FormPlanevaTemas from '../../../planeva_temas/components/FormPlanevaTemas';
import { setActivoPtemEvaluacionesAction } from '../../../ptem_evaluaciones/PtemEvaluacionesAction';
import FormPtemEvaluaciones from '../../../ptem_evaluaciones/components/FormPtemEvaluaciones';
import { setDetallesPlanEvaluacionAction } from '../../PlanEvaluacionAction';
import EstadisticasPlanEvaluacion from './EstadisticasPlanEvaluacion';
import InfoPlanEvaluacion from './InfoPlanEvaluacion';
import TemasPlanEvaluacion from './TemasPlanEvaluacion';

const DetallesPlanEvaluacionComponent = ({ data }) => {
  const dispatch = Redux.useDispatch();

  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const planEvaluacionStore = Redux.useSelector(
    (state) => state.planEvaluacion,
  );
  const planevaTemasStore = Redux.useSelector((state) => state.planevaTemas);
  const ptemEvaluacionesStore = Redux.useSelector(
    (state) => state.ptemEvaluaciones,
  );
  const pevaActividadesStore = Redux.useSelector(
    (state) => state.pevaActividades,
  );
  const actividadesExtrasStore = Redux.useSelector(
    (state) => state.actividadesExtras,
  );

  const activo = data ?? planEvaluacionStore.activo;

  const [tab, setTab] = React.useState('1');

  const handleTabs = (event, newValue) => {
    setTab(newValue);
  };

  const [openModalForm, setOpenModalForm] = React.useState(false);
  const [isEdit, setIsEdit] = React.useState(false);
  const [tipo, setTipo] = React.useState(0);

  const [isDesc, setIsDecs] = React.useState(false);
  const [totalPuntos, setTotalPuntos] = React.useState(0);

  React.useEffect(() => {
    const fetchData = () => {
      let t = 0;
      activo.temas.forEach((tema) => {
        tema.evaluaciones.forEach((eva) => {
          eva.instrumentos.forEach((act) => {
            t = t + Number(act.ponderacion);
          });
        });
      });
      setTotalPuntos(t);
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [planEvaluacionStore.activo]);

  React.useEffect(() => {
    const fetchData = () => {
      if (!openModalForm) {
        setDetallesPlanEvaluacionAction(dispatch, null, null);
        setActivoPlanevaTemasAction(dispatch, null);
        setActivoPtemEvaluacionesAction(dispatch, null);
        setActivoPevaActividadesAction(dispatch, null);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openModalForm]);

  function viewForm() {
    switch (tipo) {
      case 0:
        return <FormPlanevaTemas setOpenModalForm={setOpenModalForm} />;
      case 1:
        return (
          <FormPtemEvaluaciones
            totalPuntosRestantes={
              entidadesStore.ajustes.ponderacion - totalPuntos
            }
            setOpenModalForm={setOpenModalForm}
          />
        );
      case 2:
        return <FormPevaActividades setOpenModalForm={setOpenModalForm} />;
      default:
        return null;
    }
  }

  return (
    <Grid container spacing={1}>
      <LoadingWidget isLoading={planEvaluacionStore.loadingUpdateEstatus} />
      {['1', '2'].includes(tab) && (
        <Grid item xs={12} md={4}>
          <InfoPlanEvaluacion
            activo={activo}
            planEvaluacionStore={planEvaluacionStore}
          />
        </Grid>
      )}
      <Grid item xs={12} md={['1', '2'].includes(tab) ? 8 : 12}>
        <Paper elevation={4}>
          <TabContext value={tab}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleTabs} aria-label="lab API tabs example">
                <Tab label="Plan de evaluación" value="1" />
                <Tab
                  label={`Actividades extras (${actividadesExtrasStore.all.length})`}
                  value="2"
                />
                <Tab label="Lista de reprobados" value="3" />
                <Tab label="Gráfica de aprobación" value="4" />
              </TabList>
            </Box>
            <TabPanel value="1">
              <Stack direction="row" justifyContent="space-between">
                {entidadesStore.ajustes.ponderacion !== totalPuntos && (
                  <BotonComponent
                    click={async () => {
                      setTipo(0);
                      setActivoPlanevaTemasAction(dispatch, null);
                      setOpenModalForm(true);
                    }}
                    green={true}
                    text="AGREGAR TEMA"
                    addIcon
                    mr={2}
                  />
                )}
                <div>
                  {(loginStore.isRoot ||
                    loginStore.isAdmin ||
                    loginStore.isTeacher) && (
                    <BotonComponent
                      click={() => {
                        setIsEdit(!isEdit);
                        if (isEdit) {
                          setDetallesPlanEvaluacionAction(dispatch, null, null);
                          setActivoPlanevaTemasAction(dispatch, null);
                          setActivoPtemEvaluacionesAction(dispatch, null);
                          setActivoPevaActividadesAction(dispatch, null);
                        }
                      }}
                      white={!isEdit}
                      blue={isEdit}
                      text={
                        isEdit
                          ? 'CERRAR CONSTRUCCIÓN'
                          : 'CONSTRUIR PLAN DE EVALUACIÓN'
                      }
                      editIcon
                      mr={2}
                    />
                  )}
                  <BotonComponent
                    white={!isDesc}
                    blue={isDesc}
                    text="DESCRIPCIÓN"
                    searchIcon
                    click={() => setIsDecs(!isDesc)}
                  />
                </div>
              </Stack>
              <TemasPlanEvaluacion
                isEdit={isEdit}
                setTotalPuntos={setTotalPuntos}
                setOpenModalForm={setOpenModalForm}
                isDesc={isDesc}
                setTipo={setTipo}
                planEvaluacion={activo}
                puntos={totalPuntos}
              />
            </TabPanel>
            <TabPanel value="2" sx={{ p: 2 }}>
              <ActividadesExtrasView />
            </TabPanel>
            <TabPanel value="3" sx={{ p: 2 }}>
              <EstadisticasPlanEvaluacion num={1} />
            </TabPanel>
            <TabPanel value="4" sx={{ p: 2 }}>
              <EstadisticasPlanEvaluacion num={2} />
            </TabPanel>
          </TabContext>
        </Paper>
      </Grid>
      <ModalComponent
        id="modalFormPlanevaTemas"
        title={
          tipo === 0
            ? `${planevaTemasStore.activo ? 'Editar' : 'Agregar'} tema`
            : tipo === 1
            ? `${
                ptemEvaluacionesStore.activo ? 'Editar' : 'Agregar'
              } evaluación`
            : `${pevaActividadesStore.activo ? 'Editar' : 'Agregar'} actividad`
        }
        open={openModalForm}
        maxWidth="sm"
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        {viewForm()}
      </ModalComponent>
    </Grid>
  );
};

export default DetallesPlanEvaluacionComponent;
